import {
  EDIT_CLIENT,
  FETCH_CLIENT,
  DELETE_CLIENT,
  FETCH_CLIENT_CASHBACK,
} from './ClientActions'

const INITIAL_STATE = {
  items: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  filters: [],
  editingClient: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CLIENT.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        filters: action.payload.filters,
        totalSize: action.payload.data.meta.total,
        page: action.payload.data.meta.current_page,
        sizePerPage: action.payload.data.meta.per_page,
      }
    case EDIT_CLIENT.SUCCESS:
      return {
        ...state,
        editingClient: action.payload,
      }
    case FETCH_CLIENT_CASHBACK.SUCCESS:
      return {
        ...state,
        cashback: action.payload.data?.data,
      }
    case 'ERASE_CLIENT_CASHBACK':
      return {
        ...state,
        cashback: {},
      }
    default:
      return state
  }
}

export const getClientListData = state => {
  return {
    items: state.client.items,
    page: state.client.page,
    sizePerPage: state.client.sizePerPage,
    totalSize: state.client.totalSize,
  }
}

export const getEditingClient = state => {
  return state.client.editingClient
}
